module.exports = __webpack_public_path__ + "img/45_32.6953ab2f.png";